<template>
    <v-container fluid class="px-15 mx-15">
      <Alertas
        :notificacaoSocket="alertaSocket"
        :texto="alerta.texto"
        :tipo="alerta.tipo"
      ></Alertas>
  
      <v-form v-model="isValido">
        <v-row align="center">
          <v-col cols="12">
            <v-toolbar flat>
              <v-toolbar-title>| Placar de Movimentação Mensal/Anual</v-toolbar-title>
            </v-toolbar>
          </v-col>
  
          <v-col cols="12">
            <v-autocomplete
              v-model="formRelatorio.filtrosRelatorio.anoSelecionado"
              :items="listaDeAnos"
              label="Ano"
              autocomplete="off"
              clearable
              :rules="[rules.requeridoTipo]"
            ></v-autocomplete>
          </v-col>
  
          <v-col cols="12">
            <v-autocomplete
              v-model="formRelatorio.filtrosRelatorio.mesesSelecionados"
              :items="listaDeMeses"
              chips
              multiple
              clearable
              label="Meses"
              autocomplete="off"
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeMes(data.item)"
                >
                  {{ data.item.text }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
  
          <v-col cols="12">
            <v-autocomplete
              v-model="formRelatorio.filtrosRelatorio.itensSelecionados"
              :items="listaDeItens"
              :loading="!listaDeItens"
              :readonly="!listaDeItens"
              :no-data-text="loadingAutocomplete.noDataTextProduto"
              chips
              multiple
              label="Lista de Produtos em Estoque"
              autocomplete="off"
              prepend-icon="mdi-file-table"
            >
              <template v-slot:selection="data">
                <v-chip
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  close
                  @click="data.select"
                  @click:close="removeItem(data.item)"
                >
                  {{ data.item.text }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
  
          <v-col cols="12" lg="6">
            <v-autocomplete
              v-model="formRelatorio.filtrosRelatorio.descricaoCpf"
              :items="listaDePaciente"
              :loading="!listaDePaciente"
              :readonly="!listaDePaciente"
              :no-data-text="loadingAutocomplete.noDataTextPaciente"
              :search-input.sync="searchPaciente"
              clearable
              @keydown="buscarPacientes"
              label="Pacientes"
              autocomplete="off"
              prepend-icon="mdi-account-group-outline"
            ></v-autocomplete>
          </v-col>
  
          <v-col cols="12" lg="6">
            <v-autocomplete
              v-model="formRelatorio.filtrosRelatorio.numeroSetor"
              :items="listaDeSetores"
              :loading="!listaDeSetores"
              :readonly="!listaDeSetores"
              :no-data-text="loadingAutocomplete.noDataTextSetor"
              label="Setores"
              autocomplete="off"
              clearable
              prepend-icon="mdi-domain"
            ></v-autocomplete>
          </v-col>
  
          <v-col cols="12" align="center">
            <v-btn
              :disabled="btnGerarRelatorio"
              width="300"
              color="#3cbc62"
              class="white--text"
              @click="gerarRelatorio"
            >
              GERAR RELATÓRIO
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
  
      <Loading :open="loading" />
  
      <FormRelatorio
        :isTheModalOpen="formRelatorio.isOpen"
        :modalTitleToolbar="formRelatorio.modalTitleToolbar"
        v-on:fecharModal="formRelatorioClose"
        v-on:generate-excel="saveExcel(formRelatorio.dataRelatorio)"
      >
        <v-row class="pa-4">
          <v-col cols="12">
            <v-card elevation="0">
              <v-card-title>• Produtos Dispensados para Pacientes - {{ formRelatorio.dataRelatorio.anoSelecionado }}</v-card-title>
              <v-row class="pb-16">
                <v-col v-if="formRelatorio.dataRelatorio.itensAgrupadosPaciente.length > 0" cols="12">
                  <DataTable
                    :tableHeader="headerItensAgrupados"
                    :tableRows="formRelatorio.dataRelatorio.itensAgrupadosPaciente"
                  ></DataTable>
                </v-col>
                <v-col v-else cols="12">
                  <v-card-text>
                    <span class="text-subtitle-1 font-weight-light">Não é possível de exibir a tabela dos produtos dispensados para pacientes, pois, não há dados suficientes.</span>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
  
        <v-row class="py-8">
          <v-col cols="12">
            <v-divider />
          </v-col>
        </v-row>
  
        <v-row class="pa-4">
          <v-col cols="12">
            <v-card elevation="0">
              <v-card-title>• Produtos Dispensados para Setores - {{ formRelatorio.dataRelatorio.anoSelecionado }}</v-card-title>
              <v-row class="pb-16">
                <v-col v-if="formRelatorio.dataRelatorio.itensAgrupadosSetor.length > 0" cols="12">
                  <DataTable
                    :tableHeader="headerItensAgrupados"
                    :tableRows="formRelatorio.dataRelatorio.itensAgrupadosSetor"
                  ></DataTable>
                </v-col>
                <v-col v-else cols="12">
                  <v-card-text>
                    <span class="text-subtitle-1 font-weight-light">Não é possível de exibir a tabela dos produtos dispensados para setores, pois, não há dados suficientes.</span>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </FormRelatorio>
    </v-container>
  </template>
  
  <script>
  import axios from "../plugins/axios";
  import store from "@/store/index";
  import FormRelatorio from "../components/FormRelatorio";
  import DataTable from "@/components/DataTable2.vue";
  import { Workbook } from "exceljs";
  import { saveAs } from "file-saver";
  import Blob from "blob";
  import Alertas from "../components/Alertas.vue";
  import Loading from "../components/Loading.vue";
  
  export default {
    components: {
      FormRelatorio,
      DataTable,
      Loading,
      Alertas
    },
  
    data: () => ({
      alerta: {
        texto: "",
        tipo: "",
      },
  
      alertaSocket: {
        texto: "",
        tipo: "",
      },
  
      config: {
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": store.state.token,
        },
      },
  
      btnGerarRelatorio: false,
      isValido: true,
      loading: false,
      temSubestoque: false,
  
      page: 1,
      searchPaciente: null,
  
      loadingAutocomplete: {
        noDataTextProduto: "Carregando a lista de produtos...",
        noDataTextPaciente: "Carregando a lista de pacientes...",
        noDataTextSetor: "Carregando lista de setores...",
      },
  
      //formRelatorio
      formRelatorio: {
        isOpen: false,
        modalTitleToolbar: "Placar de Movimentação Mensal/Anual gerado",
        filtrosRelatorio: {
          numeroEndereco: store.state.numeroEndereco,
          descricaoCpf: null,
          numeroSetor: null,
          anoSelecionado: null,
          itensSelecionados: [],
          mesesSelecionados: []
        },
        dataRelatorio: {
          anoSelecionado: null,
          mesesSelecionados: [],
          itensAgrupadosPaciente: [],
          itensAgrupadosSetor: [],
        },
      },
  
      //#region HEADERS
      headerItensAgrupados: [
        {
          text: "Nome do Produto",
          value: "nomeItem",
        },
      ],
      //#endregion
  
      listaDeItens: [],
      listaDePaciente: [],
      listaDeSetores: [],
      listaDeAnos: [],
      listaDeMeses: [
        { value: 1, text: "JANEIRO" },
        { value: 2, text: "FEVEREIRO" },
        { value: 3, text: "MARÇO" },
        { value: 4, text: "ABRIL" },
        { value: 5, text: "MAIO" },
        { value: 6, text: "JUNHO" },
        { value: 7, text: "JULHO" },
        { value: 8, text: "AGOSTO" },
        { value: 9, text: "SETEMBRO" },
        { value: 10, text: "OUTUBRO" },
        { value: 11, text: "NOVEMBRO" },
        { value: 12, text: "DEZEMBRO" },
      ],
  
      rules: {
        required: (value) => value.length > 0 || "Requer o campo!",
        requeridoTipo: (value) => value != null || "Requer o campo!",
      },
    }),
  
    created() {
      this.gerarListaDeAnos();
      this.initialize();
    },
  
    watch: {
      isValido() {
        this.btnGerarRelatorio = !this.isValido;
      },
      searchPaciente() {
        if(!this.searchPaciente) {
          this.listaPaciente();
        }
      }
    },
  
    methods: {
      //#region Initialize e Listagens
      async initialize() {
        try {
          this.listaItens();
          this.listaPaciente();
          this.listaSetores();
        } catch (error) {
          console.log(error)
        }
      },
  
      async listaItens() {
        try {
  
          const responseItens = await axios.put("itemSistemaUnidade", {numeroEndereco: store.state.numeroEndereco}, this.config);
  
          if(responseItens.data.length == 0) {
            this.loadingAutocomplete.noDataTextProduto = "Não há produtos cadastrados"
          }
  
          this.listaDeItens = responseItens.data.map((row) => {
            return { 
              value: row.itemSistemaUnidade.numeroItemSistemaUnidade,
              text: row.itemSistema.nomeItemSistema,
              numeroItemSistema: row.itemSistema.numeroItemSistema,
              numeroItemSistemaUnidade: row.itemSistemaUnidade.numeroItemSistemaUnidade,
              quantidadeEstoque: row.quantidadeEstoqueTotal,
            };
          });
        } catch (error) {
          this.alerta.texto = error.response.data.message;
          this.alerta.tipo = "erro";
        } 
      },
  
      async listaPaciente() {
        try {
          let responsePaciente = await axios.put("listarPacientePagination", {page: this.page, search: this.searchPaciente} ,this.config);
  
          if(responsePaciente.data.length == 0) {
            this.loadingAutocomplete.noDataTextPaciente = "Não há pacientes cadastrados"
          }
  
          this.listaDePaciente = responsePaciente.data.map((pacienteSelecionado) => {
            if(pacienteSelecionado.descricaoCpf) {
              return {
                value: pacienteSelecionado.descricaoCpf,
                text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  CPF: " + pacienteSelecionado.descricaoCpf,
              };
            } else if(!pacienteSelecionado.descricaoCpf && pacienteSelecionado.descricaoRG) {
              return {
                value: pacienteSelecionado.descricaoCpf,
                text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  RG: " + pacienteSelecionado.descricaoRG,
              };
            } else if(!pacienteSelecionado.descricaoCpf && !pacienteSelecionado.descricaoRG && pacienteSelecionado.descricaoCpfResponsavel) {
              return {
                value: pacienteSelecionado.descricaoCpf,
                text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  CPF do Responsável: " + pacienteSelecionado.descricaoCpfResponsavel,
              };
            } else {
              return {
                value: pacienteSelecionado.descricaoCpf,
                text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  Não há dados informados!",
              };
            }
          });
        } catch (error) {
          this.alerta.texto = error.response.data.message;
          this.alerta.tipo = "erro";
        }
      },
  
      async listaSetores() {
        try {
          let responseSetor = await axios.put("setorUnidade", { numeroEndereco: store.state.numeroEndereco }, this.config);
  
          if(responseSetor.data.length == 0) {
            this.loadingAutocomplete.noDataTextSetor = "Não há setor cadastrado"
          }
  
          this.listaDeSetores = responseSetor.data.map((row) => {
            return { 
              value: row.numeroSetor,
              text: row.nomeSetor
            };
          });
        } catch (error) {
          this.alerta.texto = error.response.data.message;
          this.alerta.tipo = "erro";
        }
      },

      gerarListaDeAnos() {
        const anoAtual = new Date().getFullYear();
        for (let i = 2021; i <= anoAtual; i++) {
          this.listaDeAnos.push({
            value: i,
            text: i
          });
        }
      },
      //#endregion
  
      async gerarRelatorio() {
        this.alerta.tipo = "";
        this.loading = true;
        try {
          if(this.formRelatorio.filtrosRelatorio.anoSelecionado) {
            if(this.formRelatorio.filtrosRelatorio.mesesSelecionados.length == 0) {
              this.formRelatorio.filtrosRelatorio.mesesSelecionados = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
            }
  
            this.formRelatorio.filtrosRelatorio.mesesSelecionados.sort((a, b) => a - b);
  
            const responseRelatorio = await axios.put(
              "relatorioSaidaMensal",
              this.formRelatorio.filtrosRelatorio,
              this.config
            );
  
            this.formRelatorio.filtrosRelatorio.mesesSelecionados.map(mesSelecionado => {
              this.headerItensAgrupados.push(this.adicionarHeader(mesSelecionado))
            })
            this.headerItensAgrupados.push({ text: "Total", value: "total" })
            
            this.formRelatorio.dataRelatorio.anoSelecionado = this.formRelatorio.filtrosRelatorio.anoSelecionado;
            this.formRelatorio.dataRelatorio.mesesSelecionados = this.formRelatorio.filtrosRelatorio.mesesSelecionados;
            this.formRelatorio.dataRelatorio.itensAgrupadosPaciente = responseRelatorio.data.itensAgrupadosPaciente;
            this.formRelatorio.dataRelatorio.itensAgrupadosSetor = responseRelatorio.data.itensAgrupadosSetor;
          } else {
            this.alerta.texto = "Por favor selecione o ano antes de continuar!";
            this.alerta.tipo = "erro";
          }
  
        } catch (error) {
          this.alerta.texto = error.response.data.message;
          this.alerta.tipo = "erro";
        } finally {
          this.loading = false;
          this.formRelatorio.isOpen = true;
        }
      },
  
      formRelatorioClose() {
        this.formRelatorio.dataRelatorio.anoSelecionado = null;
        this.formRelatorio.dataRelatorio.itensAgrupadosPaciente = [];
        this.formRelatorio.dataRelatorio.itensAgrupadosSetor = [];

        this.headerItensAgrupados = [
          {
            text: "Nome do Produto",
            value: "nomeItem",
          },
        ],
  
        this.formRelatorio.isOpen = false;
      },
  
      removeItem(item) {
        const index = this.formRelatorio.filtrosRelatorio.itensSelecionados.indexOf(item.value);
        if (index >= 0)
          this.formRelatorio.filtrosRelatorio.itensSelecionados.splice(index, 1);
      },
  
      removeMes(item) {
        const index = this.formRelatorio.filtrosRelatorio.mesesSelecionados.indexOf(item.value);
        if (index >= 0)
          this.formRelatorio.filtrosRelatorio.mesesSelecionados.splice(index, 1);
      },
  
      async buscarPacientes(){ 
        await this.listaPaciente()
      },
  
      //#region FORMATERS
      formatDate1(dateDe) {
        if (!dateDe) return null;
  
        const [day, month, year] = dateDe.split("-");
        return `${year}/${month}/${day}`;
      },
  
      parseDate1(dateDe) {
        if (!dateDe) return null;
        const [day, month, year] = dateDe.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      },
  
      formatDate2(dateAte) {
        if (!dateAte) return null;
        const [day, month, year] = dateAte.split("-");
        return `${year}/${month}/${day}`;
      },
  
      parseDate2(dateAte) {
        if (!dateAte) return null;
        const [day, month, year] = dateAte.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      },
  
      _formatStringInBrazilianDateFormat(data) {
        if (!data) return 'Sem Data';
        let ano = data.split("-")[0];
        let mes = data.split("-")[1];
        let dia = data.split("-")[2];
        let dia2 = dia.substring(0, 2);
  
        return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
      },
  
      formataFamilia(indicador) {
        switch (indicador) {
          case null: return "Não vinculado"
          case 0: return "Não vinculado"
          case 1: return "Medicações"
          case 2: return "Materiais"
          case 3: return "Psicotrópicos"
          case 4: return "Saneantes"
          case 5: return "Cosméticos"
          case 6: return "Nutrição"
          case 7: return "Antimicrobianos"
          case 8: return "Amostra Grátis"
          case 9: return "Maleta de Emergência"
          case 10: return "Doação"
          case 11: return "Teste Rápido"
          case 12: return "USO INTERNO"
        }
      },
  
      formataTipoDispensa(tipo) {
        switch (tipo) {
          case 0: return "Comum"
          case 1: return "UTI"
          case 2: return "Enfermaria"
          case 3: return "Centro Cirúrgico"
        }
      },
  
      adicionarHeader(mesSelecionado) {
        switch (mesSelecionado) {
          case 1: return { text: "Janeiro", value: "totalJaneiro" }
          case 2: return { text: "Fevereiro", value: "totalFevereiro" }
          case 3: return { text: "Março", value: "totalMarco" }
          case 4: return { text: "Abril", value: "totalAbril" }
          case 5: return { text: "Maio", value: "totalMaio" }
          case 6: return { text: "Junho", value: "totalJunho" }
          case 7: return { text: "Julho", value: "totalJulho" }
          case 8: return { text: "Agosto", value: "totalAgosto" }
          case 9: return { text: "Setembro", value: "totalSetembro" }
          case 10: return { text: "Outubro", value: "totalOutubro" }
          case 11: return { text: "Novembro", value: "totalNovembro" }
          case 12: return { text: "Dezembro", value: "totalDezembro" }
        }
      },
      
      adicionarValorExcel(mesSelecionado, dados) {
        switch (mesSelecionado) {
          case 'totalJaneiro': return dados.totalJaneiro
          case 'totalFevereiro': return dados.totalFevereiro
          case 'totalMarco': return dados.totalMarco
          case 'totalAbril': return dados.totalAbril
          case 'totalMaio': return dados.totalMaio
          case 'totalJunho': return dados.totalJunho
          case 'totalJulho': return dados.totalJulho
          case 'totalAgosto': return dados.totalAgosto
          case 'totalSetembro': return dados.totalSetembro
          case 'totalOutubro': return dados.totalOutubro
          case 'totalNovembro': return dados.totalNovembro
          case 'totalDezembro': return dados.totalDezembro
        }
      },
  
      formataLetraExcel(tipo) {
        switch (tipo) {
          case 1: return "B"
          case 2: return "C"
          case 3: return "D"
          case 4: return "E"
          case 5: return "F"
          case 6: return "G"
          case 7: return "H"
          case 8: return "I"
          case 9: return "J"
          case 10: return "K"
          case 11: return "L"
          case 12: return "M"
          case 13: return "N"
        }
      },
      //#endregion
  
      //#region Excel
      saveExcel(conteudo) {
        try {
          const workbook = new Workbook();
  
          var borderStyles = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
  
          //#region DISPENSA PACIENTE
          var worksheetItensPaciente = workbook.addWorksheet("Dispensados para Pacientes", {
            properties: { tabColor: { argb: "FF00FF00" } },
            views: [{ showGridLines: false }],
          });
  
          worksheetItensPaciente.columns = [
            { key: "col1", width: 60 },
            { key: "col2", width: 30 },
            { key: "col3", width: 30 },
            { key: "col4", width: 30 },
            { key: "col5", width: 30 },
            { key: "col6", width: 30 },
            { key: "col7", width: 30 },
            { key: "col8", width: 30 },
            { key: "col9", width: 30 },
            { key: "col10", width: 30 },
            { key: "col11", width: 30 },
            { key: "col12", width: 30 },
            { key: "col13", width: 30 },
            { key: "col14", width: 30 },
          ];
  
          let posicaoLinhaItensPaciente = 1;
          worksheetItensPaciente.mergeCells('A' + posicaoLinhaItensPaciente + ':' + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) +''+ posicaoLinhaItensPaciente);
          worksheetItensPaciente.getCell('A'+posicaoLinhaItensPaciente).value = 'Produtos Dispensados para Pacientes - ' + conteudo.anoSelecionado;
          worksheetItensPaciente.getCell('A'+posicaoLinhaItensPaciente).font = { name: 'Arial', family: 2, size: 14, bold: true };
          worksheetItensPaciente.getCell('A'+posicaoLinhaItensPaciente).alignment = { vertical: 'middle', horizontal: 'center' };
          worksheetItensPaciente.getCell('A'+posicaoLinhaItensPaciente).fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'66cc99'} };
          posicaoLinhaItensPaciente++
  
          if(conteudo.itensAgrupadosPaciente.length > 0) {
            worksheetItensPaciente.getRow(posicaoLinhaItensPaciente).height = 20;
            worksheetItensPaciente.getCell('A'+posicaoLinhaItensPaciente).value = "Nome do Produto";
            worksheetItensPaciente.getCell('A'+posicaoLinhaItensPaciente).font = { name: 'Arial', family: 2, size: 12, bold: true };
            worksheetItensPaciente.getCell('A'+posicaoLinhaItensPaciente).alignment = { vertical: 'middle', horizontal: 'center' };

            conteudo.mesesSelecionados.map((mesSelecionado, index) => {
              const textoHeader = this.adicionarHeader(mesSelecionado);

              worksheetItensPaciente.getCell(`${this.formataLetraExcel(index + 1)}`+posicaoLinhaItensPaciente).value = textoHeader.text;
              worksheetItensPaciente.getCell(`${this.formataLetraExcel(index + 1)}`+posicaoLinhaItensPaciente).font = { name: 'Arial', family: 2, size: 12, bold: true };
              worksheetItensPaciente.getCell(`${this.formataLetraExcel(index + 1)}`+posicaoLinhaItensPaciente).alignment = { vertical: 'middle', horizontal: 'center' };
            })

            worksheetItensPaciente.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}`+posicaoLinhaItensPaciente).value = "Total";
            worksheetItensPaciente.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}`+posicaoLinhaItensPaciente).font = { name: 'Arial', family: 2, size: 12, bold: true };
            worksheetItensPaciente.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}`+posicaoLinhaItensPaciente).alignment = { vertical: 'middle', horizontal: 'center' };
            posicaoLinhaItensPaciente++
            
            conteudo.itensAgrupadosPaciente.map((dispensaSelecionada) => {
              worksheetItensPaciente.getCell('A'+posicaoLinhaItensPaciente).value = dispensaSelecionada.nomeItem;
              worksheetItensPaciente.getCell('A'+posicaoLinhaItensPaciente).font = { name: 'Arial', family: 2, size: 13 };
              worksheetItensPaciente.getCell('A'+posicaoLinhaItensPaciente).alignment = { vertical: 'middle', horizontal: 'left' };

              conteudo.mesesSelecionados.map((mesSelecionado, index) => {
                const textoHeader = this.adicionarHeader(mesSelecionado);
                
                worksheetItensPaciente.getCell(`${this.formataLetraExcel(index + 1)}`+posicaoLinhaItensPaciente).value = this.adicionarValorExcel(textoHeader.value, dispensaSelecionada);
                worksheetItensPaciente.getCell(`${this.formataLetraExcel(index + 1)}`+posicaoLinhaItensPaciente).font = { name: 'Arial', family: 2, size: 13 };
                worksheetItensPaciente.getCell(`${this.formataLetraExcel(index + 1)}`+posicaoLinhaItensPaciente).alignment = { vertical: 'middle', horizontal: 'left' };
              })
                
              worksheetItensPaciente.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}`+posicaoLinhaItensPaciente).value = dispensaSelecionada.total;
              worksheetItensPaciente.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}`+posicaoLinhaItensPaciente).font = { name: 'Arial', family: 2, size: 13 };
              worksheetItensPaciente.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}`+posicaoLinhaItensPaciente).alignment = { vertical: 'middle', horizontal: 'left' };

              posicaoLinhaItensPaciente++
            });
            posicaoLinhaItensPaciente++
          } else {
            worksheetItensPaciente.mergeCells('A'+posicaoLinhaItensPaciente+':' + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) +''+posicaoLinhaItensPaciente);
            worksheetItensPaciente.getCell('A'+posicaoLinhaItensPaciente).value = 'Não é possível de exibir a tabela dos produtos dispensados para pacientes, pois, não há dados suficientes.';
            worksheetItensPaciente.getCell('A'+posicaoLinhaItensPaciente).font = { name: 'Arial', family: 2, size: 13, bold: false };
            worksheetItensPaciente.getCell('A'+posicaoLinhaItensPaciente).alignment = { vertical: 'middle', horizontal: 'center' };
            posicaoLinhaItensPaciente++
          }
  
          worksheetItensPaciente.eachRow({ includeEmpty: true }, function(row) {
            row.eachCell({ includeEmpty: true }, function(cell) {
              cell.border = borderStyles;
            });
          });
          //#endregion
  
          //#region DISPENSA SETOR
          var worksheetItensSetor = workbook.addWorksheet("Dispensados para Setores", {
            properties: { tabColor: { argb: "FF00FF00" } },
            views: [{ showGridLines: false }],
          });
  
          worksheetItensSetor.columns = [
            { key: "col1", width: 60 },
            { key: "col2", width: 30 },
            { key: "col3", width: 30 },
            { key: "col4", width: 30 },
            { key: "col5", width: 30 },
            { key: "col6", width: 30 },
            { key: "col7", width: 30 },
            { key: "col8", width: 30 },
            { key: "col9", width: 30 },
            { key: "col10", width: 30 },
            { key: "col11", width: 30 },
            { key: "col12", width: 30 },
            { key: "col13", width: 30 },
            { key: "col14", width: 30 },
          ];
  
          let posicaoLinhaItensSetor = 1;
          worksheetItensSetor.mergeCells('A' + posicaoLinhaItensSetor + ':' + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) +''+ posicaoLinhaItensSetor);
          worksheetItensSetor.getCell('A'+posicaoLinhaItensSetor).value = 'Produtos Dispensados para Setores - ' + conteudo.anoSelecionado;
          worksheetItensSetor.getCell('A'+posicaoLinhaItensSetor).font = { name: 'Arial', family: 2, size: 14, bold: true };
          worksheetItensSetor.getCell('A'+posicaoLinhaItensSetor).alignment = { vertical: 'middle', horizontal: 'center' };
          worksheetItensSetor.getCell('A'+posicaoLinhaItensSetor).fill = { type: 'pattern', pattern:'solid', fgColor:{argb:'66cc99'} };
          posicaoLinhaItensSetor++
  
          if(conteudo.itensAgrupadosSetor.length > 0) {
            worksheetItensSetor.getRow(posicaoLinhaItensSetor).height = 20;
            worksheetItensSetor.getCell('A'+posicaoLinhaItensSetor).value = "Nome do Produto";
            worksheetItensSetor.getCell('A'+posicaoLinhaItensSetor).font = { name: 'Arial', family: 2, size: 12, bold: true };
            worksheetItensSetor.getCell('A'+posicaoLinhaItensSetor).alignment = { vertical: 'middle', horizontal: 'center' };

            conteudo.mesesSelecionados.map((mesSelecionado, index) => {
              const textoHeader = this.adicionarHeader(mesSelecionado);

              worksheetItensSetor.getCell(`${this.formataLetraExcel(index + 1)}`+posicaoLinhaItensSetor).value = textoHeader.text;
              worksheetItensSetor.getCell(`${this.formataLetraExcel(index + 1)}`+posicaoLinhaItensSetor).font = { name: 'Arial', family: 2, size: 12, bold: true };
              worksheetItensSetor.getCell(`${this.formataLetraExcel(index + 1)}`+posicaoLinhaItensSetor).alignment = { vertical: 'middle', horizontal: 'center' };
            })

            worksheetItensSetor.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}`+posicaoLinhaItensSetor).value = "Total";
            worksheetItensSetor.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}`+posicaoLinhaItensSetor).font = { name: 'Arial', family: 2, size: 12, bold: true };
            worksheetItensSetor.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}`+posicaoLinhaItensSetor).alignment = { vertical: 'middle', horizontal: 'center' };
            posicaoLinhaItensSetor++
            
            conteudo.itensAgrupadosSetor.map((dispensaSelecionada) => {
              worksheetItensSetor.getCell('A'+posicaoLinhaItensSetor).value = dispensaSelecionada.nomeItem;
              worksheetItensSetor.getCell('A'+posicaoLinhaItensSetor).font = { name: 'Arial', family: 2, size: 13 };
              worksheetItensSetor.getCell('A'+posicaoLinhaItensSetor).alignment = { vertical: 'middle', horizontal: 'left' };

              conteudo.mesesSelecionados.map((mesSelecionado, index) => {
                const textoHeader = this.adicionarHeader(mesSelecionado);
                
                worksheetItensSetor.getCell(`${this.formataLetraExcel(index + 1)}`+posicaoLinhaItensSetor).value = this.adicionarValorExcel(textoHeader.value, dispensaSelecionada);
                worksheetItensSetor.getCell(`${this.formataLetraExcel(index + 1)}`+posicaoLinhaItensSetor).font = { name: 'Arial', family: 2, size: 13 };
                worksheetItensSetor.getCell(`${this.formataLetraExcel(index + 1)}`+posicaoLinhaItensSetor).alignment = { vertical: 'middle', horizontal: 'left' };
              })
                
              worksheetItensSetor.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}`+posicaoLinhaItensSetor).value = dispensaSelecionada.total;
              worksheetItensSetor.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}`+posicaoLinhaItensSetor).font = { name: 'Arial', family: 2, size: 13 };
              worksheetItensSetor.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}`+posicaoLinhaItensSetor).alignment = { vertical: 'middle', horizontal: 'left' };

              posicaoLinhaItensSetor++
            });
            posicaoLinhaItensSetor++
          } else {
            worksheetItensSetor.mergeCells('A'+posicaoLinhaItensSetor+':' + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) +''+posicaoLinhaItensSetor);
            worksheetItensSetor.getCell('A'+posicaoLinhaItensSetor).value = 'Não é possível de exibir a tabela dos produtos dispensados para setores, pois, não há dados suficientes.';
            worksheetItensSetor.getCell('A'+posicaoLinhaItensSetor).font = { name: 'Arial', family: 2, size: 13, bold: false };
            worksheetItensSetor.getCell('A'+posicaoLinhaItensSetor).alignment = { vertical: 'middle', horizontal: 'center' };
            posicaoLinhaItensSetor++
          }
          
          worksheetItensSetor.eachRow({ includeEmpty: true }, function(row) {
            row.eachCell({ includeEmpty: true }, function(cell) {
              cell.border = borderStyles;
            });
          });
          //#endregion
  
          workbook.xlsx.writeBuffer().then(function(data) {
            var blob = new Blob([data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blob, "Placar de Movimentação Mensal/Anual.xlsx");
          });
  
          this.rowPosition = 0;
        } catch (error) {
          console.log(error);
        }
      },
      //#endregion
  
    },
  };
  </script>
  